var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeMath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Math"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_2850_81)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "body",
    x: 18.8064,
    y: 17.4818,
    width: 42.3872,
    height: 45.0364,
    rx: 1.7551,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "field",
    x: 24.1049,
    y: 22.7802,
    width: 33.115,
    height: 9.27221,
    fill: "#6F3765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "button_equals",
    d: "M46.6232 36.0262H55.2331C56.3304 36.0262 57.22 36.9158 57.22 38.0131V55.233C57.22 56.3303 56.3304 57.2199 55.2331 57.2199H46.6232V36.0262Z",
    fill: "#FA9628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "button_divide",
    d: "M36.0264 46.623H45.2986V57.2199H36.0264V46.623Z",
    fill: "#FDC434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "button_addition",
    d: "M36.0264 36.0262H45.2986V45.2985H36.0264V36.0262Z",
    fill: "#FDC434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "button_divide_2",
    d: "M24.1049 46.623H34.7017V57.2199H26.0918C24.9944 57.2199 24.1049 56.3303 24.1049 55.233V46.623Z",
    fill: "#FDC434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "button_subtract",
    d: "M26.0918 36.0262H34.7017V45.2985H24.1049V38.0131C24.1049 36.9158 24.9944 36.0262 26.0918 36.0262Z",
    fill: "#FDC434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "symbol_equals",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9085 44.6362H49.9347V45.9608H53.9085V44.6362ZM53.9084 47.2854H49.9346V48.61H53.9084V47.2854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "symbol_divide",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3247 49.9346C41.3247 50.3004 41.0281 50.5969 40.6624 50.5969C40.2966 50.5969 40.0001 50.3004 40.0001 49.9346C40.0001 49.5688 40.2966 49.2723 40.6624 49.2723C41.0281 49.2723 41.3247 49.5688 41.3247 49.9346ZM38.0132 51.2592H43.3116V52.5838H38.0132V51.2592ZM40.6623 54.5707C41.0281 54.5707 41.3246 54.2742 41.3246 53.9084C41.3246 53.5426 41.0281 53.2461 40.6623 53.2461C40.2965 53.2461 40 53.5426 40 53.9084C40 54.2742 40.2965 54.5707 40.6623 54.5707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M28.7409 51.2592V49.2723H30.0655V51.2592H32.0524V52.5838H30.0655V54.5707H28.7409V52.5838H26.754V51.2592H28.7409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "symbol_mult",
    d: "M41.8542 38.6754L42.6492 39.47L41.4571 40.6621L42.6492 41.8543L41.8542 42.6492L40.6625 41.4568L39.4704 42.6492L38.6754 41.8543L39.8675 40.6621L38.6754 39.47L39.4704 38.6754L40.6625 39.8675L41.8542 38.6754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "symbol_subtract",
    d: "M26.754 40.0001H32.0524V41.3247H26.754V40.0001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_81",
    x1: 59.2593,
    y1: 3.79377e-7,
    x2: 18.8889,
    y2: 75.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F114C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#871B71"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeMath);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;